import * as d3 from 'd3';
import { NumberFormatHelper } from '../..';

export interface OwnAxisFormat {
    min: number;
    max: number;
    identifier: string;
    color: string;
    format: (n: number) => string;
}

export function OwnAxes(series: any[], individualScales: { [identifier: string]: d3.scale.Linear<number, number> }): OwnAxisFormat[] {
    const ownAxis: OwnAxisFormat[] = series
        .filter((s: any) => (s.hasOwnAxis && s.hasOwnAxis()) && s.isVisible())
        .map(s => {
            const scale = individualScales[s.identifier()];
            let res: OwnAxisFormat;
            if (scale) {
                const domain = scale.domain();
                const min = domain[0];
                const max = domain[1];
                res = {
                    min,
                    max,
                    color: s.color(),
                    format: NumberFormatHelper.getFormat(min, max),
                    identifier: s.identifier()
                };
            } else {
                res = {
                    min: null,
                    max: null,
                    color: s.color(),
                    format: () => '',
                    identifier: s.identifier()
                };
            }
            return res;
        });
    return ownAxis;
}